import API from './modules/API/API';
import Games from './modules/Games/Games';
import Localization from './modules/Localization/Localization';
import Posts from './modules/Posts/Posts';
import Teams from './modules/Teams/Teams';
import Twitter from './modules/Social/Twitter';
import Users from './modules/Users/Users';
import Utils from './modules/Utils';

class App {
  constructor() {
    this.api = new API(this);
    this.games = new Games(this);
    this.localization = new Localization(this);
    this.posts = new Posts(this);
    this.social = {
      twitter: new Twitter(this),
    };
    this.teams = new Teams(this);
    this.users = new Users(this),
    this.utils = new Utils(this);
  }
}

export default App;
